/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { IconButton, Box, Modal, Grid, Chip, Typography, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ImageCarousel from './ImageCarousel';

const CarouselImage = styled('img')({
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
});

const IMAGE_URL = 'https://cards.scryfall.io/large/front/';

const CARDS_RECEIVED = [];
const DetailedCard = ({ open, uuid, handleClose, imageSrc, total, multiImageSrc, color, setDetailedCard, phone }) => {
    const [leg, setLeg] = useState(undefined);
    const [scryfallLink, setLink] = useState(undefined);
    const [similar, setSimilar] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCardIndex, setSelectedCardIndex] = useState(0);

    useEffect(() => {
        const current = multiImageSrc.findIndex((t) => t === imageSrc);
        // fetch(`https://api.scryfall.com/cards/${multiImageSrc[current].split('/').at(-1).replace('.jpg', '')}`).then((t) => t.json()).then((k) => setLink(k.scryfall_uri)).catch((t) => console.log(t));
        setSelectedCardIndex(current);
    }, [multiImageSrc, imageSrc])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '70vw',
        height: '90vh',
        bgcolor: '#fbfaf2',
        borderColor: color,
        borderWidth: '5px',
        borderStyle: 'solid',
        borderRadius: '20px',
        boxShadow: 24,
        display: 'flex',
        alignItems: 'center',
        p: phone ? 1 : 2,
    };

    const closeButton = {
        position: 'absolute',
        top: phone ? '10px' : '0px',
        right: '-50px',
        color: 'black',
        backgroundColor: '#ccccccbb',
    };

    const imageStyle = {
        height: '90%',
        width: 'auto',
        mr: 2,
        marginRight: '1em',
        display: 'block',
        margin: '0 auto',
    };

    const imageContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    };

    const smallCardStyle = {
        cursor: 'pointer',
        marginBottom: '0.5em',
    };

    // cancelar open i guardar tot el que ja hem vist
    useEffect(() => {
        if (open) {
            const card = total.find((t) => t.uuid === uuid)
            fetch(`https://api.scryfall.com/cards/${card.image_id.replace('.jpg', '')}`).then((t) => t.json()).then((k) => setLink(k.scryfall_uri)).catch((t) => console.log(t));
            if (!Object.keys(CARDS_RECEIVED).includes(card.name)) {
                setIsLoading(true);
                fetch(`https://5n34df5tdkrovbyiep3vafekni0bdfqq.lambda-url.eu-central-1.on.aws/?uuid=${uuid}`, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then((r) => r.json()).then((t) => {
                    // eslint-disable-next-line array-callback-return
                    t.map((k) => {
                        let found = total.find((t) => t.uuid === k.uuid)
                        CARDS_RECEIVED[found.name] = k;
                        if (k.uuid === uuid) {
                            const foundUUID = k;
                            setLeg(foundUUID.legalities);
                            setSimilar(foundUUID.similar_cards.map((uuid) => {const card = total.find((t) => t.uuid === uuid); return {uuid, name: card['name'], imageSrc: `${IMAGE_URL}${card.image_id[0]}/${card.image_id[1]}/${card.image_id}`}}));
                            setIsLoading(false);
                        }
                    })
                });
            } else {
                const foundUUID = CARDS_RECEIVED[card.name];
                setLeg(foundUUID.legalities);
                setSimilar(foundUUID.similar_cards.map((uuid) => {const card = total.find((t) => t.uuid === uuid); return {uuid, name: card['name'], imageSrc: `${IMAGE_URL}${card.image_id[0]}/${card.image_id[1]}/${card.image_id}`}}));
                setIsLoading(false);
                const notFound = foundUUID.similar_cards.filter((p) => {const card = total.find((t) => t.uuid === uuid); return !Object.keys(CARDS_RECEIVED).includes(card.name)});
                notFound.map((t) => {
                    fetch(`https://5n34df5tdkrovbyiep3vafekni0bdfqq.lambda-url.eu-central-1.on.aws/?uuid=${t}`, {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }).then((r) => r.json()).then((t) => {
                        // eslint-disable-next-line array-callback-return
                        t.map((k) => {
                            CARDS_RECEIVED[k.name] = k;
                        })
                    });
                })
                sessionStorage.setItem('MTGSimilar', JSON.stringify(CARDS_RECEIVED));
            }
        }
    }, [uuid, setLeg, setSimilar, total, open]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft') {
                setSelectedCardIndex((prevIndex) => {
                    const newIndex = (prevIndex > 0 ? prevIndex - 1 : multiImageSrc.length - 1);
                    fetch(`https://api.scryfall.com/cards/${multiImageSrc[newIndex].split('/').at(-1).replace('.jpg', '')}`).then((t) => t.json()).then((k) => setLink(k.scryfall_uri)).catch((t) => console.log(t));
                    return newIndex});
            } else if (event.key === 'ArrowRight') {
                setSelectedCardIndex((prevIndex) => {
                    const newIndex = (prevIndex < multiImageSrc.length - 1 ? prevIndex + 1 : 0);
                    fetch(`https://api.scryfall.com/cards/${multiImageSrc[newIndex].split('/').at(-1).replace('.jpg', '')}`).then((t) => t.json()).then((k) => setLink(k.scryfall_uri)).catch((t) => console.log(t));
                    return newIndex});
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [multiImageSrc]);

    const handleSmallCardClick = (uuid) => {
        setSelectedCardIndex(0);
        handleClose();
        setDetailedCard(total.find((t) => t.uuid === uuid));
    };

    return (
        <Modal
            open={open}
            onClose={() => { setLeg(undefined); setSelectedCardIndex(0); setSimilar([]); setLink(undefined); handleClose(); }}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box sx={style}>
                <IconButton style={closeButton} onClick={() => { setLeg(undefined); setSelectedCardIndex(0); setSimilar([]); setLink(undefined); handleClose() }}>
                    <CloseIcon />
                </IconButton>
                <Grid container spacing={1} style={{ height: '100%' }}>
                    <Grid item xs={6} style={{ height: '100%' }}>
                        <Box sx={imageContainerStyle}>
                            <ImageCarousel
                                imageStyle={imageStyle}
                                imageUrls={multiImageSrc}
                                selectedCardIndex={selectedCardIndex}
                                setSelectedCardIndex={setSelectedCardIndex}
                                setLink={setLink}
                                phone={phone}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={6} style={{ height: '95%', display: 'flex', flexDirection: 'column', overflow: 'scroll' }}>
                        <Box sx={{ flexGrow: 0, padding: '1em' }}>
                            {isLoading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <CircularProgress />
                                </Box>
                            ) :
                            (<Grid container spacing={1}>
                                {similar.length > 0 ? similar.map((obj, index) => (
                                    <Grid item xs={4} key={obj.uuid}>
                                        <Box sx={smallCardStyle} onClick={() => handleSmallCardClick(obj.uuid)}>
                                            <CarouselImage
                                                style={{
                                                    width: '90%',
                                                    height: 'auto',
                                                    marginBottom: '5px'
                                                }}
                                                alt={`Image ${obj.uuid}`}
                                                src={obj.imageSrc}
                                                setLink={setLink}
                                                phone={phone}
                                            />
                                            <Typography variant="caption" align="center" sx={{display: 'block',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'}}>
                                                {obj.name}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                )) : <></>}
                            </Grid>)
                            }
                        </Box>
                        <Box sx={{ flexGrow: 1, padding: '1em' }}>
                        {
                            phone ? <></> : isLoading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <CircularProgress />
                                </Box>
                            ) : 
                            (<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, width: '100%' }}>
                                {leg ? Object.entries(leg).map(([format, isLegal]) => (
                                    <Chip
                                        key={format}
                                        label={format}
                                        color={isLegal === 'Legal' ? "success" : isLegal === 'Restricted' ? "warning" : "error"}
                                        sx={{ margin: '0px' }}
                                    />
                                )) : <></>}
                            </Box>) }
                        </Box>
                        <Typography variant="body1" gutterBottom style={{
                                    position: 'absolute',
                                    bottom: '2%',
                                    right: '2%',
                                    color: 'black',
                                    display: 'flex',
                                    fontSize: '18px',
                                    fontFamily: 'Montserrat, sans-serif',
                                }}>
                                {scryfallLink ? <a href={scryfallLink} target="_blank" rel="noreferrer" style={{color: '#01204E',fontWeight: 900}}>
                                        Link to Scryfall
                                        </a> : <></>}
                            </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
};

export default DetailedCard;